import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import moment, { Moment } from "moment";
import { STATIC_COL_WIDTH } from "@/Domains/DispositionManagement/Constants";
import { Theme, Tooltip } from "@mui/material";
import { useAppSelector } from "@/Redux/Redux";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface VehicleAvailabilityProps {
    startdate: string | Moment;
    enddate: string | Moment;
    contentWidth: number | undefined;
    type: string | null;
}

const useStyles = makeStyles()((theme: Theme) => ({
    notAvailable: {
        position: "absolute",
        backgroundColor:"red",
        backgroundImage:
            "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAALklEQVQYlWNggIJ79+79X7x05f979+79xyqGUwJNjAGvKUhihK1EBtRVPAQ8AwBA9Mqpev2QZgAAAABJRU5ErkJggg==)",
        zIndex: 0,
        height: 52,
        opacity: 0.6,
    },
}));

const VehicleAvailability: FunctionComponent<VehicleAvailabilityProps> = ({
    startdate,
    enddate,
    contentWidth,
    type,
}): JSX.Element => {
    const { classes } = useStyles();
    const disposition = useAppSelector((state) => state.disposition);
    const { t } = useTranslation();

    if (contentWidth === undefined) {
        contentWidth = 0;
    } else {
        contentWidth -= STATIC_COL_WIDTH;
    }

    startdate = moment.utc(startdate);
    enddate = moment.utc(enddate);

    if (startdate.isBefore(moment.utc(disposition.dispositionStartdate))) {
        startdate = moment.utc(disposition.dispositionStartdate);
    }

    if (enddate.isSameOrAfter(moment.utc(disposition.dispositionEnddate))) {
        enddate = moment.utc(disposition.dispositionEnddate).add(1, "days");
    }

    const dayWidthInPixel =
        ((disposition.dayWidth * contentWidth) / 100) * disposition.singleDay;

    const offsetDays = startdate.diff(
        moment.utc(disposition.dispositionStartdate),
        "days",
        true,
    );
    const duration = enddate.diff(startdate, "days", true) * dayWidthInPixel;

    const leftPos = offsetDays * dayWidthInPixel + STATIC_COL_WIDTH;

    return (
        <Tooltip
            title={
                type == "active"
                    ? t("disposition.controls.tooltip.vehicleNotInStock")
                    : t("disposition.controls.tooltip.vehicleDrowry")
            }
        >
            <div
                className={classes.notAvailable}
                style={{ left: leftPos + "px", width: duration + "px" }}
            />
        </Tooltip>
    );
};

export default VehicleAvailability;
